export default {
  startDate: 'Start date',
  endDate: 'End date',
  submitFilter: 'Submit',
  clearButton: 'Clear',
};
